import dayjs from "dayjs";
import 'dayjs/locale/en'; 
import "dayjs/locale/ar";
import customParseFormat from 'dayjs/plugin/customParseFormat';

export function formatDateToFullString(dateString: string,  locale: string = 'en'): string {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };
  try {
    return date.toLocaleDateString(locale, options);
  } catch (e) {
    console.error('Error formatting date with locale', locale, e);
    return date.toLocaleDateString('en-US', options);
  }
}


export const formatDate = (dateString: string) => {
  return dayjs(dateString).format("ddd, MMM DD ");
};

export const formatDateRange = (value: [dayjs.Dayjs | null, dayjs.Dayjs | null], locale: string) => {
  if (!value[0] || !value[1]) return "";
  return `${value[0].locale(locale).format("DD MMM, YYYY")} - ${value[1].locale(locale).format("DD MMM, YYYY")}`;

};

export const formatDateToDayAndMonth = (dateString: string | null, locale: string = 'en'): string => {
  
  if (!dateString) return '';
  
  let date = dayjs(dateString);
  
  if (!date.isValid()) {
    date = dayjs(dateString, 'YYYY-MM-DD');
  }
  
  if (!date.isValid()) {
    date = dayjs(dateString, 'DD-MM-YYYY');
  }
  
  if (!date.isValid()) {
    console.error("Invalid date format:", dateString);
    return 'Invalid Date';
  }
  
  return date.locale(locale).format("ddd, DD MMM");
};



dayjs.extend(customParseFormat);

export const formatLocalizedDate = (dateString: string, locale: string = 'en'): string => {
  if (!dateString) {
    console.warn("formatLocalizedDate: Empty date string");
    return '';
  }

  const parsedDate = dayjs(dateString, 'DD-MM-YYYY');
  if (!parsedDate.isValid()) {
    console.warn("formatLocalizedDate: Unable to parse date:", dateString);
    return '';
  }

  return parsedDate.locale(locale).format('ddd, DD MMM YYYY');
};

export const formatFlightDate   = (dateString: string, locale: string = 'en') => {
  return dayjs(dateString).locale(locale).format('ddd, DD MMM');
};